/* Página de obra: selector de tamaño, silueta a escala, chip del QR, atribución y barra móvil. */
(function () {
  const root = document.getElementById('cm-artwork');
  if (!root) return;
  const i18n = safeJson('cm-i18n') || {};
  const qrCodes = safeJson('cm-qr-codes') || {};
  const originalW = parseFloat(root.dataset.widthCm) || 0;
  const originalH = parseFloat(root.dataset.heightCm) || 0;

  function safeJson(id) {
    try { return JSON.parse(document.getElementById(id).textContent); } catch (e) { return null; }
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c])); }

  /* ---------- Atribución QR (localStorage, sin cookies) ---------- */
  const params = new URLSearchParams(location.search);
  const code = (params.get('utm_campaign') || params.get('src') || '').toUpperCase();
  let attr = null;
  try { attr = JSON.parse(localStorage.getItem('cm_attr') || 'null'); } catch (e) {}
  if (code && qrCodes[code]) {
    attr = { code, artwork: qrCodes[code].artwork, locationId: qrCodes[code].locationId, location: qrCodes[code].location, city: qrCodes[code].city, at: Date.now(), utm: Object.fromEntries([...params].filter(([k]) => k.startsWith('utm_'))) };
    try { localStorage.setItem('cm_attr', JSON.stringify(attr)); } catch (e) {}
  }
  const chip = document.getElementById('cm-qr-chip');
  if (chip && attr && attr.location && attr.artwork === root.dataset.handle && Date.now() - attr.at < 7 * 864e5) {
    document.getElementById('cm-qr-chip-text').textContent = (i18n.hanging_here || 'This painting is hanging right here at {location}').replace('{location}', attr.location + (attr.city ? ' · ' + attr.city : ''));
    chip.hidden = false;
  }

  /* ---------- Selector de tamaño ---------- */
  const sizes = document.getElementById('cm-sizes');
  const variantInput = document.getElementById('cm-print-variant');
  const priceEl = document.getElementById('cm-print-price');
  const silhouette = document.getElementById('cm-silhouette');

  function parseSizeCm(title) {
    const cm = title.match(/(\d+(?:[.,]\d+)?)\s*[x×]\s*(\d+(?:[.,]\d+)?)\s*cm/i);
    if (cm) return { w: parseFloat(cm[1].replace(',', '.')), h: parseFloat(cm[2].replace(',', '.')) };
    const inch = title.match(/(\d+(?:[.,]\d+)?)\s*[x×]\s*(\d+(?:[.,]\d+)?)\s*(?:in|")/i);
    if (inch) return { w: parseFloat(inch[1]) * 2.54, h: parseFloat(inch[2]) * 2.54 };
    const any = title.match(/(\d+(?:[.,]\d+)?)\s*[x×]\s*(\d+(?:[.,]\d+)?)/);
    if (any) return { w: parseFloat(any[1]) * 2.54, h: parseFloat(any[2]) * 2.54 };
    return null;
  }

  function drawSilhouette(paper) {
    if (!silhouette) return;
    const svg = silhouette.querySelector('svg');
    const legend = document.getElementById('cm-silhouette-legend');
    if (!paper || !svg) { silhouette.hidden = true; return; }
    const landscape = originalW > originalH;
    const p = landscape && paper.w < paper.h ? { w: paper.h, h: paper.w } : paper;
    const personH = 170;
    const maxH = Math.max(personH, originalH || 0, p.h);
    const H = 170;                 // alto útil en px
    const scale = H / maxH;        // px por cm
    const baseline = H + 6;
    const gap = 22;
    let x = 8;
    const parts = [];
    // persona 1.70 m
    const ph = personH * scale, pw = 44 * scale;
    const cx = x + pw / 2, headR = 11 * scale, top = baseline - ph;
    parts.push(`<g fill="none" stroke="#6B6864" stroke-width="1.4" stroke-linecap="round">
      <circle cx="${cx}" cy="${top + headR}" r="${headR}"/>
      <line x1="${cx}" y1="${top + headR * 2}" x2="${cx}" y2="${baseline - 70 * scale}"/>
      <line x1="${cx}" y1="${top + headR * 2 + 12 * scale}" x2="${cx - pw / 2}" y2="${top + headR * 2 + 60 * scale}"/>
      <line x1="${cx}" y1="${top + headR * 2 + 12 * scale}" x2="${cx + pw / 2}" y2="${top + headR * 2 + 60 * scale}"/>
      <line x1="${cx}" y1="${baseline - 70 * scale}" x2="${cx - pw / 2.6}" y2="${baseline}"/>
      <line x1="${cx}" y1="${baseline - 70 * scale}" x2="${cx + pw / 2.6}" y2="${baseline}"/>
    </g>`);
    x += pw + gap;
    // original
    if (originalW && originalH) {
      const ow = originalW * scale, oh = originalH * scale;
      parts.push(`<rect x="${x}" y="${baseline - oh}" width="${ow}" height="${oh}" fill="#1C1B19"/>`);
      x += ow + gap;
    }
    // print
    const prw = p.w * scale, prh = p.h * scale;
    parts.push(`<rect x="${x}" y="${baseline - prh}" width="${prw}" height="${prh}" fill="#FFFFFF" stroke="#1C1B19" stroke-width="1.4"/>`);
    const width = Math.max(240, x + prw + 8);
    svg.setAttribute('viewBox', `0 0 ${width} ${baseline + 8}`);
    svg.style.maxHeight = '19rem';
    const title = svg.querySelector('title');
    svg.innerHTML = (title ? title.outerHTML : '') + `<line x1="0" y1="${baseline}" x2="${width}" y2="${baseline}" stroke="#C9C3B8"/>` + parts.join('');
    if (legend) {
      legend.innerHTML =
        `<li><i class="is-person"></i>${esc(i18n.person_label || '1.70 m')}</li>` +
        (originalW && originalH ? `<li><i class="is-original"></i>${esc(i18n.original_label || 'Original')} ${Math.round(originalW)}×${Math.round(originalH)} cm</li>` : '') +
        `<li><i></i>${esc(i18n.print_label || 'Print')} ${Math.round(p.w)}×${Math.round(p.h)} cm</li>`;
    }
    const cap = document.getElementById('cm-silhouette-caption');
    if (cap) cap.textContent = i18n.scale_caption || '';
    silhouette.hidden = false;
  }

  function applySize(input) {
    if (!input) return;
    if (variantInput) variantInput.value = input.value;
    if (priceEl && input.dataset.price) priceEl.textContent = input.dataset.price;
    drawSilhouette(parseSizeCm(input.dataset.title || ''));
    const sticky = document.getElementById('cm-sticky-price');
    if (sticky && input.dataset.price) sticky.textContent = input.dataset.price;
  }
  if (sizes) {
    sizes.addEventListener('change', (e) => { if (e.target.name === 'cm-size') applySize(e.target); });
    applySize(sizes.querySelector('input:checked') || sizes.querySelector('input:not(:disabled)'));
  }

  /* ---------- Barra móvil ---------- */
  const bar = document.getElementById('cm-sticky-bar');
  const buy = document.querySelector('.cm-buy');
  if (bar && buy && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      const visible = entries.some((en) => en.isIntersecting);
      bar.classList.toggle('is-visible', !visible && window.scrollY > 300);
      bar.setAttribute('aria-hidden', visible ? 'true' : 'false');
    }, { threshold: 0.05 });
    io.observe(buy);
  }
})();
